// extracted by mini-css-extract-plugin
module.exports = {"logoSpan":"LogoWithText_logoSpan__n8h4y"};